export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/CertifiedCarBadge.72db4cfe.svg","height":97,"width":114,"blurWidth":0,"blurHeight":0};